import { TCustomerJourney } from '@iwoca/frontend-tracking-library/lib/Types';

export const AMPLITUDE_CATEGORY: { [key: string]: TCustomerJourney } = {
    ACCOUNT_PAGES: 'Account pages',
    ACCOUNT_PAGES_DE: 'Account pages DE',
    APPROVAL: 'Approval',
    APPROVAL_DE: 'Approval DE',
    DRAWDOWN: 'Drawdown',
    DRAWDOWN_DE: 'Drawdown DE'
};
